import React from 'react';
import { Edit } from 'react-admin';
import ResourceUploadCreate from './ResourceUploadCreate';

/**
 * Resource upload editor
 */
const ResourceuploadEdit = props => {
  const {
    hasEditPermission,
    hasDeletePermission,
    hasCreatePermission,
    hasReadPermission,
    userProfile,
    ...rest
  } = props;

  return (
    <Edit {...rest} undoable={false} title={<></>}>
      <ResourceUploadCreate {...props} isEdit={true} />
    </Edit>
  );
};

export default ResourceuploadEdit;
